import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import SerieIndex from '../pages/SerieIndex.vue';

import SerieItem from '../components/SerieItem.vue';
import SerieFeaturedItem from '../components/SerieFeaturedItem.vue';
import SearchInput from '../components/SearchInput.vue';
class SerieIndexComponent {
  constructor({ container, pinnedTags }) {
    this.app = null;
    this.container = container;
    this.pinnedTags = pinnedTags;
  }

  init() {
    const props = { pinnedTags: this.pinnedTags };
    this.app = createApp(SerieIndex, props);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('serie-item', SerieItem);
    this.app.component('featured-serie-item', SerieFeaturedItem);
    this.app.component('search-input', SearchInput);
    this.app.mount(this.container);
  }
}

export default SerieIndexComponent;
